import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { URL_SERVICES } from '../../config/config';
import { Congreso } from '../../models/congreso.model';
import { UserService } from '../user/user.service';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Observable } from 'rxjs/Observable';

import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;

@Injectable()
export class CongresosService {

  constructor(public http: HttpClient, public _userService: UserService) { }

  getCongresos( desde: number ) {
    let url = URL_SERVICES + '/congreso?from=' + desde;

    return this.http.get(url)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this._userService.logout();
      }
      return Observable.throw(err);
    });
  }

  getCongreso( id: string ) {
    let url = URL_SERVICES + '/congreso/' + id;

    return this.http.get(url)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this._userService.logout();
      }
      return Observable.throw(err);
    });
  }

  buscarCongreso(busqueda: string) {
    let url = URL_SERVICES + '/congreso/buscar/' + busqueda;

    return this.http.get(url)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this._userService.logout();
      }
      return Observable.throw(err);
    });
  }

  guardarCongreso( congreso: Congreso ) {
    let url = URL_SERVICES + '/congreso';
    if ( congreso._id ) {
      url = url + '/' + congreso._id + '?token=' + this._userService.token;

      return this.http.put(url, congreso).map((resp: any) => {
        return resp.congreso;
      })
      .catch(err => {
        console.log(err);
        if (err.status === 401) {
          swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
          this._userService.logout();
        }
        return Observable.throw(err);
      });
    } else {
      url = url + '?token=' + this._userService.token;

      return this.http.post(url, congreso).map((resp: any) => {
        return resp.congreso;
      })
      .catch(err => {
        console.log(err);
        if (err.status === 401) {
          swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
          this._userService.logout();
        }
        return Observable.throw(err);
      });
    }
  }

  borrarCongreso(congreso: Congreso) {
    let url = URL_SERVICES + '/congreso/' + congreso._id + '?token=' + this._userService.token;
    return this.http.delete(url).map((resp: any) => {
      return resp.congreso;
    })
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this._userService.logout();
      }
      return Observable.throw(err);
    });
  }

  // Metodos Categoria Inscripcion

  addCategoriaInscripcion(congresoCategoriaInscripcion: any, congreso_id: string) {
    let url = URL_SERVICES + '/congresocateginscripcion?token=' + this._userService.token;
    let object: any = { congreso: congreso_id,
                        categoriaInscripcion: congresoCategoriaInscripcion.categoriaInscripcion._id,
                        precio: congresoCategoriaInscripcion.precio,
                        precio_usd: congresoCategoriaInscripcion.precio_usd };

    return this.http.post(url, object)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this._userService.logout();
      }
      return Observable.throw(err);
    });
  }

  deleteCategoriaInscripcion(congresoCategoriaInscripcion_id: string) {
    let url = URL_SERVICES +
              '/congresocateginscripcion/' + congresoCategoriaInscripcion_id +
              '?token=' + this._userService.token;
    return this.http.delete(url)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this._userService.logout();
      }
      return Observable.throw(err);
    });
  }

  editarCategoriaInscripcion(congresoCategoriaInscripcion_id: string, precio: number, precio_usd: number) {
    let url = URL_SERVICES +
              '/congresocateginscripcion/' + congresoCategoriaInscripcion_id +
              '?token=' + this._userService.token;
    let object: any = {precio: precio, precio_usd: precio_usd};
    return this.http.put(url, object)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this._userService.logout();
      }
      return Observable.throw(err);
    });
  }

  // Metodos Actividades

  addActividad(congresoActividad: any, congreso_id: string) {
    let url = URL_SERVICES + '/congresoactividades?token=' + this._userService.token;
    let object: any = { congreso: congreso_id,
                        actividad: congresoActividad.actividad._id,
                        precio: congresoActividad.precio,
                        precio_usd: congresoActividad.precio_usd };

    return this.http.post(url, object)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this._userService.logout();
      }
      return Observable.throw(err);
    });
  }

  deleteActividad(congresoActividad_id: string) {
    let url = URL_SERVICES +
              '/congresoactividades/' + congresoActividad_id +
              '?token=' + this._userService.token;
    return this.http.delete(url)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this._userService.logout();
      }
      return Observable.throw(err);
    });
  }

  editarActividad(congresoActividad_id: string, precio: number, precio_usd: number) {
    let url = URL_SERVICES +
              '/congresoactividades/' + congresoActividad_id +
              '?token=' + this._userService.token;
    let object: any = {precio: precio, precio_usd: precio_usd};
    return this.http.put(url, object)
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this._userService.logout();
      }
      return Observable.throw(err);
    });
  }

  activarCongreso(congreso: Congreso) {
    let url = URL_SERVICES + '/congreso/activar/' + congreso._id + '?token=' + this._userService.token;

    return this.http.put(url, {}).map((resp: any) => {
      return resp.congreso;
    })
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this._userService.logout();
      }
      return Observable.throw(err);
    });
  }

  getCongresoActivo() {
    let url = URL_SERVICES + '/congreso/activo/buscar';

    return this.http.get(url).map((resp: any) => {
      return resp.congreso;
    })
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this._userService.logout();
      }
      return Observable.throw(err);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/congresos/congresos.service.ts